module.exports = __webpack_public_path__ + "static/img/Ellie-Carpenter.1090023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ellie-Carpenter.jpg
// module id = XGYB
// module chunks = 0